import { nodeNameToFactoryId } from "../compiler/utils/nodeNameToFactoryId";
import { Connection } from "../parser/definition/types/Connection";
import { SourceConnection } from "./types/SourceConnection";

export function convertConnectionsToChildConnections(connections: Array<Connection<keyof any, any, any>>): Array<SourceConnection> {
    return connections.map((connection) => {
        let fromNodeId = nodeNameToFactoryId(connection.from.childName.toString());
        let fromPortName = connection.from.portName;
        let toNodeId = nodeNameToFactoryId(connection.to.childName.toString());
        let toPortName = connection.to.portName;

        let childConnection: SourceConnection = [
            [fromNodeId, fromPortName],
            [toNodeId, toPortName]
        ];
        return childConnection;
    })
}